import * as libraries_gui_definition_lib_libraries_client_lib_types_client_bindings_alan_api from "./lib/libraries/gui_definition_lib/libraries/client_lib/types/client_bindings/alan_api";
import * as libraries_gui_definition_lib_libraries_control_bundle_lib_libraries_controls_lib_types_control_library_alan_api from "./lib/libraries/gui_definition_lib/libraries/control_bundle_lib/libraries/controls_lib/types/control_library/alan_api";
import * as libraries_gui_definition_lib_libraries_model_lib_types_application_alan_api from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/application/alan_api";
import * as libraries_gui_definition_lib_libraries_model_lib_types_application_serializer_json from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/application/serializer_json";
import * as libraries_gui_definition_lib_libraries_model_lib_types_client_protocol_reply_alan_api from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/client_protocol_reply/alan_api";
import * as libraries_gui_definition_lib_libraries_model_lib_types_client_protocol_reply_serializer_json from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/client_protocol_reply/serializer_json";
import * as libraries_gui_definition_lib_libraries_model_lib_types_client_protocol_request_alan_api from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/client_protocol_request/alan_api";
import * as libraries_gui_definition_lib_libraries_model_lib_types_client_protocol_request_serializer_json from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/client_protocol_request/serializer_json";
import * as libraries_gui_definition_lib_libraries_model_lib_types_client_reply_alan_api from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/client_reply/alan_api";
import * as libraries_gui_definition_lib_libraries_model_lib_types_client_reply_serializer_json from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/client_reply/serializer_json";
import * as libraries_gui_definition_lib_libraries_model_lib_types_client_request_alan_api from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/client_request/alan_api";
import * as libraries_gui_definition_lib_libraries_model_lib_types_client_request_serializer_json from "./lib/libraries/gui_definition_lib/libraries/model_lib/types/client_request/serializer_json";
import * as libraries_gui_definition_lib_types_collation_table_alan_api from "./lib/libraries/gui_definition_lib/types/collation_table/alan_api";
import * as libraries_gui_definition_lib_types_gui_model_alan_api from "./lib/libraries/gui_definition_lib/types/gui_model/alan_api";
import * as libraries_gui_definition_lib_types_main_alan_api from "./lib/libraries/gui_definition_lib/types/main/alan_api";
import * as libraries_gui_definition_lib_types_parameters_alan_api from "./lib/libraries/gui_definition_lib/types/parameters/alan_api";
import * as libraries_gui_definition_lib_types_phrases_alan_api from "./lib/libraries/gui_definition_lib/types/phrases/alan_api";
import * as libraries_gui_definition_lib_types_query_alan_api from "./lib/libraries/gui_definition_lib/types/query/alan_api";
import * as libraries_gui_definition_lib_types_settings_alan_api from "./lib/libraries/gui_definition_lib/types/settings/alan_api";
import * as libraries_gui_definition_lib_types_translations_alan_api from "./lib/libraries/gui_definition_lib/types/translations/alan_api";
import * as libraries_gui_definition_lib_types_views_alan_api from "./lib/libraries/gui_definition_lib/types/views/alan_api";
import * as libraries_gui_definition_lib_types_widget_alan_api from "./lib/libraries/gui_definition_lib/types/widget/alan_api";
import * as report_protocol_types_arguments_alan_api from "./lib/report_protocol_types/arguments/alan_api";
import * as report_protocol_types_arguments_serializer_json from "./lib/report_protocol_types/arguments/serializer_json";
import * as report_protocol_types_collection_query_to_table_alan_api from "./lib/report_protocol_types/collection_query_to_table/alan_api";
import * as report_protocol_types_collection_query_to_table_serializer_json from "./lib/report_protocol_types/collection_query_to_table/serializer_json";
import * as report_protocol_types_report_protocol_download_request_alan_api from "./lib/report_protocol_types/report_protocol_download_request/alan_api";
import * as report_protocol_types_report_protocol_download_request_serializer_json from "./lib/report_protocol_types/report_protocol_download_request/serializer_json";
import * as report_protocol_types_report_protocol_reply_alan_api from "./lib/report_protocol_types/report_protocol_reply/alan_api";
import * as report_protocol_types_report_protocol_reply_serializer_json from "./lib/report_protocol_types/report_protocol_reply/serializer_json";
import * as report_protocol_types_report_protocol_request_alan_api from "./lib/report_protocol_types/report_protocol_request/alan_api";
import * as report_protocol_types_report_protocol_request_serializer_json from "./lib/report_protocol_types/report_protocol_request/serializer_json";
import * as types_application_identifier_alan_api from "./lib/types/application_identifier/alan_api";
import * as types_application_identifier_serializer_json from "./lib/types/application_identifier/serializer_json";
import * as types_client_state_alan_api from "./lib/types/client_state/alan_api";
import * as types_client_state_serializer_json from "./lib/types/client_state/serializer_json";
import * as types_modifications_alan_api from "./lib/types/modifications/alan_api";
import * as types_modifications_serializer_json from "./lib/types/modifications/serializer_json";
import * as types_test_alan_api from "./lib/types/test/alan_api";
export namespace libraries {
    export namespace gui_definition_lib {
        export namespace libraries {
            export namespace client_lib {
                export namespace types {
                    export namespace client_bindings {
                        export import alan_api = libraries_gui_definition_lib_libraries_client_lib_types_client_bindings_alan_api;
                    }
                }
            }
            export namespace control_bundle_lib {
                export namespace libraries {
                    export namespace controls_lib {
                        export namespace types {
                            export namespace control_library {
                                export import alan_api = libraries_gui_definition_lib_libraries_control_bundle_lib_libraries_controls_lib_types_control_library_alan_api;
                            }
                        }
                    }
                }
                export namespace types {

                }
            }
            export namespace model_lib {
                export namespace types {
                    export namespace application {
                        export import alan_api = libraries_gui_definition_lib_libraries_model_lib_types_application_alan_api;
                        export import serializer_json = libraries_gui_definition_lib_libraries_model_lib_types_application_serializer_json;
                    }
                    export namespace client_protocol_reply {
                        export import alan_api = libraries_gui_definition_lib_libraries_model_lib_types_client_protocol_reply_alan_api;
                        export import serializer_json = libraries_gui_definition_lib_libraries_model_lib_types_client_protocol_reply_serializer_json;
                    }
                    export namespace client_protocol_request {
                        export import alan_api = libraries_gui_definition_lib_libraries_model_lib_types_client_protocol_request_alan_api;
                        export import serializer_json = libraries_gui_definition_lib_libraries_model_lib_types_client_protocol_request_serializer_json;
                    }
                    export namespace client_reply {
                        export import alan_api = libraries_gui_definition_lib_libraries_model_lib_types_client_reply_alan_api;
                        export import serializer_json = libraries_gui_definition_lib_libraries_model_lib_types_client_reply_serializer_json;
                    }
                    export namespace client_request {
                        export import alan_api = libraries_gui_definition_lib_libraries_model_lib_types_client_request_alan_api;
                        export import serializer_json = libraries_gui_definition_lib_libraries_model_lib_types_client_request_serializer_json;
                    }
                }
            }
        }
        export namespace types {
            export namespace collation_table {
                export import alan_api = libraries_gui_definition_lib_types_collation_table_alan_api;
            }
            export namespace gui_model {
                export import alan_api = libraries_gui_definition_lib_types_gui_model_alan_api;
            }
            export namespace main {
                export import alan_api = libraries_gui_definition_lib_types_main_alan_api;
            }
            export namespace parameters {
                export import alan_api = libraries_gui_definition_lib_types_parameters_alan_api;
            }
            export namespace phrases {
                export import alan_api = libraries_gui_definition_lib_types_phrases_alan_api;
            }
            export namespace query {
                export import alan_api = libraries_gui_definition_lib_types_query_alan_api;
            }
            export namespace settings {
                export import alan_api = libraries_gui_definition_lib_types_settings_alan_api;
            }
            export namespace translations {
                export import alan_api = libraries_gui_definition_lib_types_translations_alan_api;
            }
            export namespace views {
                export import alan_api = libraries_gui_definition_lib_types_views_alan_api;
            }
            export namespace widget {
                export import alan_api = libraries_gui_definition_lib_types_widget_alan_api;
            }
        }
    }
}
export namespace report_protocol_types {
    export namespace arguments_ {
        export import alan_api = report_protocol_types_arguments_alan_api;
        export import serializer_json = report_protocol_types_arguments_serializer_json;
    }
    export namespace collection_query_to_table {
        export import alan_api = report_protocol_types_collection_query_to_table_alan_api;
        export import serializer_json = report_protocol_types_collection_query_to_table_serializer_json;
    }
    export namespace report_protocol_download_request {
        export import alan_api = report_protocol_types_report_protocol_download_request_alan_api;
        export import serializer_json = report_protocol_types_report_protocol_download_request_serializer_json;
    }
    export namespace report_protocol_reply {
        export import alan_api = report_protocol_types_report_protocol_reply_alan_api;
        export import serializer_json = report_protocol_types_report_protocol_reply_serializer_json;
    }
    export namespace report_protocol_request {
        export import alan_api = report_protocol_types_report_protocol_request_alan_api;
        export import serializer_json = report_protocol_types_report_protocol_request_serializer_json;
    }
}
export namespace types {
    export namespace application_identifier {
        export import alan_api = types_application_identifier_alan_api;
        export import serializer_json = types_application_identifier_serializer_json;
    }
    export namespace client_state {
        export import alan_api = types_client_state_alan_api;
        export import serializer_json = types_client_state_serializer_json;
    }
    export namespace modifications {
        export import alan_api = types_modifications_alan_api;
        export import serializer_json = types_modifications_serializer_json;
    }
    export namespace test {
        export import alan_api = types_test_alan_api;
    }
}